export const buildGridPillRect = (
  container: HTMLElement | null,
  rowIndex: number
): DOMRect | null => {
  if (!container) return null
  const viewport = container.querySelector('.ag-body-viewport')
  const rowEl = container.querySelector(`.ag-row[row-index="${rowIndex}"]`)
  if (!viewport || !rowEl) return null
  const viewportRect = viewport.getBoundingClientRect()
  const rowRect = rowEl.getBoundingClientRect()
  return new DOMRect(0, rowRect.top, viewportRect.right, rowRect.height)
}
